var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1119({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "11.5 1.94 4.5 1.94 1 8 4.5 14.06 11.5 14.06 15 8 11.5 1.94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "5.08 13.06 2.15 8 5.08 2.94 10.92 2.94 13.85 8 10.92 13.06 5.08 13.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1119);
export default __webpack_public_path__ + "static/media/Symbolpack_1_119.330e58c5a62c3b3f0f29b7eb528edb3d.svg";
export { ForwardRef as ReactComponent };